<div ngbDropdown #dropdown='ngbDropdown' [autoClose]="'outside'" [display]="'static'" class="dropdown-wrapper" (click)="dropdownIsOpen(dropdown.isOpen())">
  <button ngbDropdownToggle
    class="dropdown-button"
    data-cy="dropdown-toggle-button">
    <app-tooltip message="{{getButtonPlaceholder() | JoinArrayStringsPipe}}" [dynamic]="true">
      <div class="dropdown-button-text" [ngClass]="{'bold': hasSelectedOption()}">
        <span data-cy="dropdown-toggle-button-placeholder">{{getButtonPlaceholder() | JoinArrayStringsPipe}}</span>
      </div>
    </app-tooltip>

        <span [ngClass]="{
                'iwp-icon-gen_arrow_down': !dropdown.isOpen(),
                'iwp-icon-gen_arrow_up': dropdown.isOpen()
            }"
      class="dropdown-toggle-button-arrow"
    data-cy="dropdown-toggle-button-arrow"></span>
  </button>
  <div ngbDropdownMenu class="dropdown-menu-wrapper">
    @for (entry of dropdownData | keyvalue: originalOrder; track entry) {
      <button ngbDropdownItem
        class="dropdown-item bold"
        [attr.data-cy]="dropdownItemDataCy(entry.value.name, true)"
        [disabled]="entry.value.disabled"
        (mouseenter)="openDropdownSubMenu(entry.key)"
        (mouseleave)="closeDropdownSubMenu()">
        <span class="dropdown-item-text"
        [attr.data-cy]="dropdownItemDataCy(entry.value.name)">{{ entry?.value.name }}</span>
        @if (hasDropdownItemDataToShow(entry.key)) {
          <span
            [ngClass]="{'iwp-icon-gen_arrow_up': true}"
            [attr.data-cy]="dropdownItemDataCy(entry.value.name)"
          class="dropdown-item-toggle"></span>
        }
        @if (showSubDropdownMenu(entry.key)) {
          <div ngbDropdownMenu class="sub-dropdown-menu-wrapper">
            @for (subEntry of getSubDropdownData(entry.key) | keyvalue: originalOrder; track subEntry) {
              <button ngbDropdownItem
                class="dropdown-item"
                [attr.data-cy]="dropdownItemDataCy(subEntry.value.name, true)"
                [class.disable]="subEntry.value.disabled"
                (click)="handleSubDropdownClick(entry.key, subEntry.key, subEntry.value)">
                <span class="dropdown-item-text"
                [attr.data-cy]="dropdownItemDataCy( subEntry.value.name)">{{ subEntry.value.name }}</span>
              </button>
            }
          </div>
        }
      </button>
    }
  </div>
</div>
